import { IconHandbagSimple } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { Subscription as SubscriptionType } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useDrawerState } from '../../../Drawer'
import { useConditions } from '../useConditions'
import { SubscriptionEditor } from './Editor'
import { messages } from './messages'
import { SubscriptionView } from './View'

interface Props {
  name: string
}

export function Subscription(props: Props) {
  const { name } = props

  const { $t } = useIntl()

  const { form } = useFormStateContext()
  const config: SubscriptionType | undefined = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: $t(messages.title),
    icon: <IconHandbagSimple />,
  })

  const handleSave = (values: SubscriptionType | undefined) =>
    form.setValue(name, values)

  return (
    <>
      <SubscriptionEditor
        state={editorState}
        initialConfig={config}
        onSave={handleSave}
      />
      <SubscriptionView
        config={config}
        onEdit={editorState.show}
        onRemove={() => handleSave(undefined)}
      />
    </>
  )
}
